import { useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { LOGOUT_IDLE_TIME_MINUTES } from 'src/constants/Constants'

export default function useIdle({ onIdle, idleTime = LOGOUT_IDLE_TIME_MINUTES }) {
  const [isIdle, setIsIdle] = useState()

  const handleOnIdle = () => {
    setIsIdle(true)
    onIdle()
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * idleTime,
    onIdle: handleOnIdle,
    debounce: 500,
    crossTab: {
      emitOnAllTabs: true,
      emitOnHiddenTabs: true,
    },
  })

  return {
    getRemainingTime,
    getLastActiveTime,
    isIdle,
  }
}
